jQuery(document).ready(function ($) {
  const body = $('body');
  const header = $('.site-header');

  $.fancybox.defaults.backFocus = false;

  // header
  $(window).on('load scroll orientationchange', function () {
    if ($(window).scrollTop() > 0) {
      header.addClass('site-header--scrolled');
    } else {
      header.removeClass('site-header--scrolled');
    }
  });

  body.on('click', '.js-toggleHeaderPopup', function (e) {
    e.preventDefault();
    const button = $(this);
    const target = $(`.${button.data('target')}`);
    const buttons = $('.site-header__button');
    const popups = $('.site-header__popup');

    buttons.not(button).removeClass('site-header__button--active');
    button.toggleClass('site-header__button--active');

    popups.not(target).stop(true, true).fadeOut(200);
    target.stop(true, true).fadeToggle(200);
  });

  body.on('click', function (e) {
    const button = $('.site-header__button');
    const popup = $('.site-header__popup');

    if (!button.is(e.target) && button.has(e.target).length === 0
      && !popup.is(e.target) && popup.has(e.target).length === 0) {
      button.removeClass('site-header__button--active');
      popup.stop(true, true).fadeOut(200);
    }
  });
  // ~ header

  const welcomeGallery = new Swiper('.welcome__slider', {
    slidesPerView: 1,
    loop: true,
    effect: "fade",
    speed: 1000,
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 12000,
    }
  });

  const servicesSlider = new Swiper('.js-servicesSlider', {
    slidesPerView: 'auto',
    spaceBetween: 17,
    freeMode: true,
  });

  body.on('click', '.js-changeService', function () {
    const tile = $(this);
    const tiles = $('.service-tile');
    const tabs = $('.services-tabs__item');

    if (!$(this).hasClass('service-tile--active')) {
      tiles.not(tile).removeClass('service-tile--active');
      tile.addClass('service-tile--active');

      tabs.hide();
      tabs.eq(tile.closest('.swiper-slide').index()).show();
    }
  });

  const worksGalleries = $('.js-worksGallery');
  if (worksGalleries.length) {
    worksGalleries.each(function () {
      const worksGallery = new Swiper('.js-worksGallery', {
        slidesPerView: 1,
        loop: false,
        effect: "fade",
        speed: 600,
        fadeEffect: {
          crossFade: true
        },
        navigation: {
          nextEl: '.works-gallery__arrow--next',
          prevEl: '.works-gallery__arrow--prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true,
        },
      });
    });
  }

  const worksSlider = new Swiper('.js-worksSlider', {
    slidesPerView: 1,
    spaceBetween: 22,
    loop: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true,
    },
    breakpoints: {
      576: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
    },
  });

  // load more posts
  let paged = 1;
  body.on('click', '.js-load-more', function(event){
    event.preventDefault();
    const link = $(this);
    const list = link.closest('.js-ajaxedList');
    let ajaxResult, options;

    paged++;
    options = {npage: paged};

    $.get(location.href, options, function(data){
      ajaxResult = $(data).find('.js-ajaxedList').html();
    }).done(function(){
      setTimeout(function(){
        list.append(ajaxResult);

        if (link.parent('.load-more').length) {
          link.parent('.load-more').remove();
        } else {
          link.remove();
        }

      }, 100);
    });
  });
  // ~ load more posts

  // read more
  body.on('click', '.js-moreLess', function (e) {
    e.preventDefault();
    const link = $(this);
    const review = link.closest('.review-tile');
    const divider = review.find('.review-tile__divider');
    const more = review.find('.review-tile__more');

    if (link.hasClass('opened')) {
      link.removeClass('opened').text('Показать ещё');
      divider.show();
      more.css('display', 'none');
    } else {
      link.addClass('opened').text('Свернуть');
      divider.hide();
      more.css('display', 'inline');
    }
  });
  // ~ read more

  // catalogue
  function convertToPrice(number, unit) {
    return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ") + ` ₽/${unit}`;
  }

  body.on('click', '.product-tile__type', function () {
    const tile = $(this).closest('.product-tile');
    const types = tile.find('.product-tile__type');
    const unit = $(this).data('unit');
    const price = $(this).data('price');

    types.removeClass('product-tile__type--active');
    $(this).addClass('product-tile__type--active');
    tile.find('.product-tile__price').text(price ? `от ${price} ₽/${unit}` : 'Цена по запросу');
  });

  function calcProductPrice() {
    const selected = $('.product-form__type--active');
    const hasPrice = !!selected.data('price');

    if (!hasPrice) {
      return 'Цена по запросу';
    }

    const input = $('.product-form__field-input');
    const dataPrice = String(selected.length ? selected.data('price') : input.data('price')).replaceAll(' ', '');
    const price = Number(dataPrice);
    const unit = selected.length ? selected.data('unit') : input.data('unit');
    const quantity = input.val();

    return convertToPrice(price * quantity, unit);
  }

  body.on('click', '.product-form__type', function () {
    const tile = $(this).closest('.product-form');
    const types = tile.find('.product-form__type');

    types.removeClass('product-form__type--active');
    $(this).addClass('product-form__type--active');
    tile.find('.product-form__price').text(calcProductPrice());
  });

  body.on('click', '.product-form__field-button', function (e) {
    e.preventDefault();
    const block = $(this).closest('.product-form__field');
    const type = $(this).data('type');
    const input = block.find('.product-form__field-input');
    let value = parseInt(input.val(), 10);

    if (type === 'less') {
      input.val(Math.max(1, value - 1));
    } else {
      input.val(value + 1);
    }

    $('.product-form__price').text(calcProductPrice());
  });

  let quantityTimeout;
  body.on('input', '.product-form__field-input', function () {
    const input = $(this);
    const value = input.val().replace(/[^0-9]/g, "");

    input.val(value);
    $('.product-form__price').text(calcProductPrice());
    clearTimeout(quantityTimeout);

    if (!value.length || parseInt(value, 10) <= 0) {
      quantityTimeout = setTimeout(function () {
        input.val(1);
        $('.product-form__price').text(calcProductPrice());
      }, 1000);
    }
  });

  body.on('click', '.js-openCharacteristicsTab', function (e) {
    e.preventDefault();
    const target = $('.product-tabs');
    const offset = target.offset().top - header.outerHeight() - 40;

    $('html, body').animate({
      scrollTop: offset
    }, 500);

    $('.js-characteristicsLink').trigger('click');
  });

  const thumbnailsSlider = $('.js-productThumbnails');
  const photoSlider = $('.js-productPhotos');

  if (thumbnailsSlider.length && photoSlider.length) {
    const thumbnails = new Swiper('.js-productThumbnails', {
      slidesPerView: 5,
      spaceBetween: 12,
      navigation: {
        nextEl: '.product-gallery__arrow--next',
        prevEl: '.product-gallery__arrow--prev',
      },
    });

    const photos = new Swiper('.js-productPhotos', {
      slidesPerView: 1,
      spaceBetween: 12,
      navigation: {
        nextEl: ".product-gallery__arrow--next",
        prevEl: ".product-gallery__arrow--prev",
      },
      thumbs: {
        swiper: thumbnails,
      }
    });
  }

  body.on('click', '.product-tabs__menu-item', function () {
    const link = $(this);
    const index = link.index();
    const links = $('.product-tabs__menu-item');
    const tabs = $('.product-tabs__item');

    links.not(link).removeClass('product-tabs__menu-item--active');
    link.addClass('product-tabs__menu-item--active');

    tabs.hide();
    tabs.eq(index).show();
  });

  $('.product-tabs__menu-item:first').trigger('click');

  body.on('click', '.js-changeCategory', function (e) {
    e.preventDefault();
    const index = $(this).index();
    const links = $('.featured-products__menu li');
    const tabs = $('.featured-products__tab');

    links.removeClass('active');
    $(this).addClass('active');
    tabs.hide();
    tabs.eq(index).show();
  });
  // ~ catalogue

  // modals
  function openModal(modal) {
    const scrSize = window.innerWidth;
    const scrAvail = body.innerWidth();
    const padRight = scrSize - scrAvail;

    body.css({
      'overflow': 'hidden',
      'padding-right': `${padRight}px`,
    });

    $(modal).fadeIn(300);
  }

  function closeModal(modal) {
    modal.fadeOut(300);

    setTimeout(function(){
      body.css({
        'overflow': 'visible',
        'padding-right': 0
      });
    }, 400);
  }

  body.on('mousedown', function (e) {
    const modal = $('.custom-modal').last();
    const modalDialog = modal.find('.custom-modal__dialog');

    if (modal.is(e.target) || modalDialog.is(e.target)) {
      closeModal(modal);
    }
  });

  body.on('click','.js-closeModal', function (e) {
    e.preventDefault();

    closeModal($(this).parents('.custom-modal'));
  });

  body.on('keydown', function (e) {
    const modal = $('.custom-modal').last();

    if (e.code === 'Escape' && modal.is(':visible')) {
      closeModal(modal);
    }
  });

  body.on('click', '.js-openRequestModal', function (e) {
    e.preventDefault();
    const modal = $('.request-modal');
    const modalTitle = $(this).data('title');
    const productTitle = $(this).data('product');
    const variation = $(this).closest('.js-product').find('.product-tile__type--active').text().trim() ||
      $(this).closest('.js-product').find('.product-form__type--active').text().trim()

    modal.find('form').trigger('reset');

    modal.find('.custom-modal__title').text(modalTitle || 'Заказать звонок');
    modal.find('[name="Request[type]"]').val(modalTitle);
    modal.find('[name="Request[product]"]').val(productTitle);
    modal.find('[name="Request[variation]"]').val(variation);

    openModal(modal);

    modal.find('.request__content').show();
    modal.find('.request__success').hide();
  });
  // ~ modals

  // phone mask
  $('.js-phoneInput').mask('+7 (000) 000-00-00', {
    placeholder: "Ваш телефон",
    clearIfNotMatch: true,
  });
  // ~ phone mask

  // request
  setTimeout(function() {
    $('[name="Request[validation]"]').val('');
    $('[name="Calculation[validation]"]').val('');
  }, 1000);

  $('.input').on('focus', function () {
    $(this).removeClass('input--error');
  });

  function checkFields(fields, ok) {
    fields.each(function () {
      const input = $(this);

      if (!input.val().length) {
        ok = false;

        input.addClass('input--error');
      }
    });

    return ok;
  }
  let formSubmitted = false;

  body.on('submit', '[data-ajax-form]', function (e) {
    e.preventDefault();
    const form = $(this);
    const formData = new FormData(this);
    const modal = $('.request-modal');
    let ok = true;

    ok = checkFields(form.find('.required'), ok);

    if (ok === true && formSubmitted === false) {
      formSubmitted = true;

      $.ajax({
        type: "POST",
        url: '/wp-admin/admin-ajax.php?action=request',
        processData: false,
        contentType: false,
        data: formData,
        success: function () {
          formSubmitted = false;
          if (modal.is(':visible')) {
            modal.find('.request__content').hide();
            modal.find('.request__success').css('display', 'flex');
          } else {
            alertify.success('Спасибо! Мы свяжемся с вами в ближайшее время');
          }
          form.trigger('reset');
        },
        error: function () {
          formSubmitted = false;
          alertify.error('Упс. Что-то пошло не так');
        },
      });
    }
  });
  // ~ request

  // mobile menu
  body.on('click', '.site-header__menu-icon', function (e) {
    e.preventDefault();
    const mobileMenu = $('.mobile-menu');
    $(this).toggleClass('site-header__menu-icon--opened');
    if (mobileMenu.hasClass('mobile-menu--opened')) {
      body.css('overflow', 'auto');
      mobileMenu.removeClass('mobile-menu--opened').fadeOut(200);
      mobileMenu.find('.mobile-menu__category').removeClass('mobile-menu__category--opened');
    } else {
      body.css('overflow', 'hidden');
      mobileMenu.fadeIn(200).addClass('mobile-menu--opened');
    }
  });

  body.on('click', '.mobile-menu__bg', function () {
    body.css('overflow', 'auto');
    $('.site-header__menu-icon').removeClass('site-header__menu-icon--opened');
    $('.mobile-menu').removeClass('mobile-menu--opened').fadeOut(200);
    $('.mobile-menu__category').removeClass('mobile-menu__category--opened');
  });

  body.on('click', '.js-goForward', function (e) {
    e.preventDefault();
    const target = $(this).data('target');

    $(`.menu-${target}`).addClass('mobile-menu__category--opened');
  });

  body.on('click', '.js-goBack', function (e) {
    e.preventDefault();
    const menu = $(this).closest('.mobile-menu__category');

    menu.removeClass('mobile-menu__category--opened');
  });
  // ~ mobile menu

  let loading = false;
  body.on('click', '.products__menu-item', function (e) {
    e.preventDefault();
    const link = $(this);
    const group = link.closest('.products');
    const links = group.find('.products__menu-item');
    const tabs = group.find('.products__tab');

    if (link.hasClass('products__menu-item--active')) return false;


    links.not(link).removeClass('products__menu-item--active');
    link.addClass('products__menu-item--active');

    tabs.hide();
    tabs.eq(link.index()).show();
  });

  // calculator
  const isCalculationPage = !!$('.js-calculationForm').length;
  let selectedSquare = 0, eventTimeout;
  let fetchingRequest = false;

  function formatMoney(value) {
    return new Intl.NumberFormat('ru-RU', {
      style: 'currency',
      currency: 'RUB',
    }).format(value);
  }

  if (isCalculationPage) {
    body.on('click', '.calculation__menu-item', function (e) {
      e.preventDefault();
      const current = $(this);
      const links = $('.calculation__menu-item');
      const categories = $('.calculation__category');

      if (current.hasClass('calculation__menu-item--active')) return false;

      links.not(current).removeClass('calculation__menu-item--active');
      current.addClass('calculation__menu-item--active');
      categories.hide();
      categories.eq(current.index()).show();
    });

    function appendProduct(target, name, quantity, price, unit) {
      target.append(`
      <div class="calculation__results-product">
        <div class="calculation__results-name">${name}</div>
        <div class="calculation__results-values">
            <span>${formatMoney(quantity * price)}</span>
            <span>${quantity} ${unit}</span>
        </div>
      </div>
    `);
    }

    function calculatePrice() {
      const selectedProducts = $('.calculation-tile--checked');
      const productsPreview = $('.calculation__results-products');
      const additionalProducts = $('.additional-list input:checked');
      const selectedBase = $('[name="Calculation[base]"]:checked');
      const baseIndex = selectedBase.data('index');
      const basementProducts = $('.calculation__basement input:checked');
      const unitPrice = $('[name="Calculation[work_price]"]').val() || 0;
      const sandSquare = $('[name="Calculation[sand_square]"]').val() || 0;
      const cementSquare = $('[name="Calculation[cement_square]"]').val() || 0;
      let materialsPrice = 0;
      let square = 0;
      let workPrice = 0;
      let totalPrice;
      let hasProducts = false;

      productsPreview.html('');
      if (selectedProducts.length) {
        selectedProducts.each(function () {
          const product = $(this);
          const variant = product.data('variant');
          const montagePrice = parseInt(product.data('montage'), 10);
          const type = product.find('input:checked');
          const price = Number(String(type.data('price')).replaceAll(/\s/g,''));
          const name = type.val();
          const quantity = Number(product.find('.js-itemsQuantity').val());
          const unit = product.find('.calculation-tile__quantity-label').html();

          if (!!quantity && quantity > 0) {
            hasProducts = true;
            materialsPrice += quantity * price;
            appendProduct(productsPreview, name, quantity, price, unit);
            if (variant === 'square') {
              square += quantity;
            }

            if (montagePrice) {
              workPrice += quantity * montagePrice;
            }
          }
        });
      } else {
        hasProducts = false;
      }

      workPrice += square * unitPrice;

      if (basementProducts.length) {
        basementProducts.each(function () {
          const product = $(this);
          const group = product.closest('.calculation__group')
          const groupTitle = group.find('.calculation__group-title').text();
          const name = product.val();
          const price = product.data('price') || 0;

          if (baseIndex !== 3) {
            selectedSquare = square;

            if (!!selectedSquare && group.is(':visible') && name !== 'Нет') {
              appendProduct(productsPreview, groupTitle !== 'Цемент' && groupTitle !== 'Геотекстиль' ? `${groupTitle}: ${name.toLowerCase()}` : groupTitle, selectedSquare, price, 'м<sup>2</sup>');
              if (groupTitle !== 'Цемент') {
                materialsPrice += selectedSquare * price;
              }
              hasProducts = true;
            }
          } else {
            selectedSquare = Number(cementSquare) + Number(sandSquare);

            if (!!square && group.is(':visible') && name !== 'Нет') {
              switch (groupTitle) {
                case 'Геотекстиль':
                  sandSquare ? appendProduct(productsPreview, groupTitle, sandSquare, price, 'м<sup>2</sup>') : null;
                  break;
                case 'Щебень':
                  sandSquare ? appendProduct(productsPreview, groupTitle, sandSquare, price, 'м<sup>2</sup>') : null;
                  break;
                case 'Песок':
                  appendProduct(productsPreview, groupTitle, square, price, 'м<sup>2</sup>');
                  break;
                default:
                  appendProduct(productsPreview, groupTitle, square, price, 'м<sup>2</sup>');
              }
              hasProducts = true;
            }
          }
        });
      }

      if (additionalProducts.length) {
        additionalProducts.each(function () {
          const product = $(this);
          const group = product.closest('.calculation__group')
          const groupTitle = group.find('.calculation__group-title').text();
          const name = product.val();
          const price = product.data('price');
          const quantity = group.find('.js-itemsQuantity').val();

          if (price > 0 && !!quantity) {
            appendProduct(productsPreview, `${groupTitle} ${name.toLowerCase()}`, quantity, price, 'шт');
            materialsPrice += quantity * price;
            hasProducts = true;
          }
        });
      }

      if (hasProducts) {
        productsPreview.show();
      } else {
        productsPreview.hide();
      }

      totalPrice = materialsPrice + workPrice;

      $('.js-materialsPrice').text(formatMoney(materialsPrice));
      $('[name="Calculation[materials]"]').val(formatMoney(materialsPrice));
      $('.js-workPrice').text(formatMoney(workPrice));
      $('[name="Calculation[work]"]').val(formatMoney(workPrice));
      $('.js-totalPrice').text(formatMoney(totalPrice));
      $('[name="Calculation[total]"]').val(formatMoney(totalPrice));
    }

    body.on('click', '.calculation-tile__checkbox', function (e) {
      e.preventDefault();
      const tile = $(this).closest('.calculation-tile');

      tile.toggleClass('calculation-tile--checked');
      if (tile.hasClass('calculation-tile--checked')) {
        tile.find('input[type=radio]:first').attr('checked', true);
      } else {
        tile.find('input[type=radio]').attr('checked', false);
      }

      calculatePrice();
    });

    body.on('input', '.js-itemsQuantity', function () {
      const input = $(this);
      const value = Number(input.val());
      const min = $(this).data('min');

      clearTimeout(eventTimeout);

      eventTimeout = setTimeout(function () {
        if (!!min && min > value) {
          const productUnit = input.closest('.calculation-tile').find('.calculation-tile__quantity-label').html();
          input.val(min);
          alertify.error(`Отгружаем только кратно поддонам: ${min} ${productUnit}`);
        }

        calculatePrice();
      }, 600);
    });

    body.on('change', '[name="Calculation[base]"]', function () {
      const index = $('[name="Calculation[base]"]:checked').data('index');
      const squares = $('.calculation__squares');
      const geotextileGroup = $('.geotextile-group');
      const rubbleGroup = $('.rubble-group');

      if (index === 3) {
        squares.css('display', 'flex');
        squares.find('input').attr('disabled', false);
      } else {
        squares.hide();
        squares.find('input').attr('disabled', true);
      }

      if (index !== 2) {
        geotextileGroup.show();
        rubbleGroup.show();

        geotextileGroup.find('input').attr('disabled', false);
        rubbleGroup.find('input').attr('disabled', false);
      } else {
        geotextileGroup.hide();
        rubbleGroup.hide();

        geotextileGroup.find('input').attr('disabled', true);
        rubbleGroup.find('input').attr('disabled', true);
      }

      calculatePrice();
    });

    body.on('input', '[name="Calculation[sand_square]"], [name="Calculation[cement_square]"]', function (e) {
      e.target.value = e.target.value.replace(/[^0-9+-]/g, '');
      calculatePrice();
    });

    body.on('change', '.calculation__basement input:radio', function () {
      calculatePrice();
    });

    body.on('change', '.calculation-tile__types input:radio', function () {
      calculatePrice();
    });

    body.on('change', '.additional-list input:radio', function () {
      const group = $(this).closest('.calculation__group');
      const input = group.find('.input');
      const price = parseInt(group.find('input:checked').data('price'), 10);

      if (price > 0) {
        input.show().attr('disabled', false);
      } else {
        input.hide().attr('disabled', true);
      }

      calculatePrice();
    });

    body.on('submit', '.js-calculationForm', function (e) {
      e.preventDefault();
      const squares = $('.calculation__squares');
      const form = $(this);
      const formData = new FormData(this);
      const calcProducts = $('.calculation__results-product');
      let ok = true;

      ok = checkFields(form.find('.required:not(:disabled)'), ok);

      if (!!calcProducts.length) {
        calcProducts.each(function () {
          const product = $(this);
          const name = product.find('.calculation__results-name').text();
          const quantity = product.find('.calculation__results-values span').eq(1).html();
          const price = product.find('.calculation__results-values span').eq(0).text();

          formData.append('Calculation[selected][]', `${quantity} ${name}: ${price}`);
        });

        formData.append('Calculation[square]', selectedSquare);
      } else {
        ok = false;
      }

      if (ok === true && fetchingRequest === false) {
        fetchingRequest = true;

        $.ajax({
          type: "POST",
          url: '/wp-admin/admin-ajax.php?action=calculation',
          processData: false,
          contentType: false,
          data: formData,
          success: function () {
            const selectedProducts = $('.calculation-tile--checked');

            fetchingRequest = false;
            form.trigger('reset');
            form.find('[name="Calculation[curb_quantity]"]').hide().attr('disabled', true);
            form.find('input:radio[data-default]').trigger('click');
            form.find('.additional-list .input').hide().attr('disabled', true);
            form.find('.product-tile').removeClass('product-tile--selected');

            squares.hide();
            squares.find('input').attr('disabled', true);

            selectedProducts.find('input[type=radio]').attr('checked', false).trigger('change');
            selectedProducts.removeClass('calculation-tile--checked');

            $('.calculation__menu-item:first-child').trigger('click');
            $('.products__menu-item:first-child').trigger('click');

            calculatePrice();

            alertify.success('Спасибо! Мы свяжемся с вами в ближайшее время');
          },
          error: function () {
            fetchingRequest = false;
            alertify.error('Упс. Что-то пошло не так');
          },
        });
      } else {
        const target = form.find('.input--error:first');
        const offset = target.offset().top - header.outerHeight() - 40;

        $('html, body').animate({
          scrollTop: offset
        }, 500);
      }
    });

    body.on('click', '.js-printResults', function (e) {
      e.preventDefault();
      window.print();
    });
  }
  // ~ calculator

  // maps
  const objectsMap = document.querySelector('#objects-map');
  const contactsMap = document.querySelector('#contacts-map');
  let isMapLoaded = false;
  let isMapInitiated = false;
  let mapInterval = null;
  let mapTimeout = null;
  let placeMarks = null;

  const initMapScript = () => {
    const mapScript = document.getElementById('ymap_lazy');
    mapScript.setAttribute('src', mapScript.getAttribute('data-src'));
    mapScript.removeAttribute('data-src');
    isMapInitiated = true;
  }

  const closeMapPopup = () => {
    $('.objects__popup').fadeOut(200);
  }

  const loadObjectsMap = () => {
    isMapLoaded = true;

    const myMap = new ymaps.Map('objects-map', {
      center: [57.1404992, 65.5548429],
      zoom: 12,
      controls: ['zoomControl'],
      autoFitToViewport: 'always',
    }, {
      zoomControlFloat: 'none',
      zoomControlPosition: {
        right: 10,
        top: 10
      },
      suppressMapOpenBlock: true,
    });

    const collection = new ymaps.GeoObjectCollection(null, {
      preset: 'islands#redCircleDotIcon',
    });

    const defaultOptions = {
      preset: 'islands#redCircleDotIcon'
    }

    const activeOptions = {
      preset: 'islands#grayCircleDotIcon'
    }

    placeMarks.map((item) => {
      const coordinates = item.coordinates.split(', ');
      if (!!Number(coordinates[0]) && !!Number(coordinates[1])) {
        const placeMark = new ymaps.Placemark([Number(coordinates[0]), Number(coordinates[1])], {
          defaultOptions,
          activeOptions,
          id: item.post_id,
          type: item.type,
        }, {
          iconImageSize: [33, 41],
          iconImageOffset: [-16, -41],
        });
        collection.add(placeMark);
      }
    });

    collection.events.add('click', function (e) {
      const activeGeoObject = e.get('target');
      const tile = $('.map__tile');
      activeGeoObject.options.set(activeGeoObject.properties.get('activeOptions'));

      tile.addClass('map-tile--loading');
      $.ajax({
        type: "POST",
        url: '/wp-admin/admin-ajax.php?action=fetch_post',
        data: {
          id: activeGeoObject.properties.get('id'),
        },
        success: function (response) {
          const content = $('.js-fetchedContent');

          content.html($(response).html());

          new Swiper('.js-popupGallery', {
            slidesPerView: 1,
            effect: "fade",
            speed: 600,
            loop: false,
            fadeEffect: {
              crossFade: true
            },
            navigation: {
              nextEl: '.works-gallery__arrow--next',
              prevEl: '.works-gallery__arrow--prev',
            },
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
              dynamicBullets: true,
            },
          });

          $('.objects__popup').fadeIn(200);
        },
      });

      collection.each(function (geoObject) {
        if (geoObject !== activeGeoObject) {
          geoObject.options.set(geoObject.properties.get('defaultOptions'));
        }
      })
    });

    myMap.behaviors.disable(['scrollZoom']);
    myMap.geoObjects.add(collection);
    myMap.setBounds(collection.getBounds(), {
      checkZoomRange: true,
      zoomMargin: 20,
    }).then(function(){
      if(myMap.getZoom() > 16) myMap.setZoom(16);
    });

    body.on('click', '.objects__menu-item', function () {
      const types = $('.objects__menu-item');
      const type = $(this).data('type');

      types.removeClass('objects__menu-item--active');
      $(this).addClass('objects__menu-item--active');

      closeMapPopup();

      collection.each(function (item){
        item.options.set(item.properties.get('defaultOptions'));

        if (type === 'all') {
          item.options.set('visible', true);
        } else {
          if (item.properties.get('type') !== type) {
            item.options.set('visible', false);
          } else {
            item.options.set('visible', true);
          }
        }
      });
    });

    body.on('click', '.objects__popup-close', function () {
      closeMapPopup();
      collection.each(function (item){
        item.options.set(item.properties.get('defaultOptions'));
      })
    });


    $(window).on('load resize orientationchange', function () {
      clearTimeout(mapTimeout);
      mapTimeout = setTimeout(function () {
        mapTimeout = null;
        myMap.setBounds(collection.getBounds(), {
          checkZoomRange: true,
          zoomMargin: 20,
        }).then(function(){
          if(myMap.getZoom() > 16) myMap.setZoom(16);
        });
      }, 200);
    });
  }

  const initObjectsMap = () => {
    if (isMapLoaded) return false;

    if (!isMapInitiated) {
      initMapScript();
    }

    mapInterval = setInterval(() => {
      if (typeof ymaps !== 'undefined') {
        clearInterval(mapInterval);
        const termId = document.querySelector('.objects__layout').dataset.term_id;

        $.ajax({
          type: "POST",
          url: '/wp-admin/admin-ajax.php?action=marks',
          data: {
            term_id: termId,
          },
          success: function (response) {
            placeMarks = JSON.parse(response);

            ymaps.ready(loadObjectsMap);
          },
        });
      }
    }, 1000);
  }

  const loadContactsMap = () => {
    isMapLoaded = true;

    const coords = contactsMap.dataset.coords.split(', ');
    const center = [Number(coords[0]), Number(coords[1])]
    const map = new ymaps.Map('contacts-map', {
      center: center,
      zoom: 11,
      controls: ['zoomControl']
    });

    const placemark = new ymaps.Placemark(center, {}, {
      iconLayout: 'default#image',
      iconImageHref: '/wp-content/themes/beton/assets/img/placemark.svg',
      iconImageSize: [54, 66],
      iconImageOffset: [-27, -66],
    });

    map.behaviors.disable('scrollZoom');
    map.geoObjects.add(placemark);
  }

  const initContactsMap = () => {
    if (isMapLoaded) return false;

    if (!isMapInitiated) {
      initMapScript();
    }

    mapInterval = setInterval(() => {
      if (typeof ymaps !== 'undefined') {
        clearInterval(mapInterval);
        ymaps.ready(loadContactsMap);
      }
    }, 1000);
  }

  if (objectsMap || contactsMap) {
    const options = {
      threshold: 0.5,
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const map = entry.target;

          if (objectsMap) {
            initObjectsMap();
          }

          if (contactsMap) {
            initContactsMap();
          }

          observer.unobserve(map);
        }
      })
    }, options);

    if (objectsMap) {
      observer.observe(objectsMap);
    }

    if (contactsMap) {
      observer.observe(contactsMap);
    }
  }

  // filters
  const filterForm  = document.querySelector('.catalogue-filter');
  const filterItems = document.querySelectorAll('.catalogue-filter__select');

  filterItems.forEach((item) => item.addEventListener('change', () => {
    const data = new FormData(filterForm);
    const isThicknessExist = !!data.get('thickness');

    if (!isThicknessExist) {
      data.delete('thickness');
    }

    const url = new URL(filterForm.action, window.location.href);

    url.search = new URLSearchParams(data).toString();
    window.location.href = url;
  }));

  // vk widget
  const widgetBlock = document.querySelector('#vk_widget');
  let isWidgetInitialized = false;
  let scriptInitialized = false;
  let widgetInterval = null;

  const initWidgetScript = () => {
    const script = document.querySelector('#vk_lazy');
    script.setAttribute('src', script.getAttribute('data-src'));
    script.removeAttribute('data-src');
    scriptInitialized = true;
  }

  const initWidget = () => {
    const widgetId = document.querySelector('#vk_lazy').dataset.id;

    if (isWidgetInitialized) return;

    if (!scriptInitialized) {
      initWidgetScript();
    }

    widgetInterval = setInterval(() => {
      if (typeof VK !== 'undefined') {
        clearInterval(widgetInterval);
        isWidgetInitialized = true;

        document.getElementById('vk_widget').innerHTML = '<div id="vk_groups"></div>';
        VK.Widgets.Group("vk_groups", {mode: 3, width: 'auto', color3: 'FF3333'}, widgetId);
      }
    }, 1000);
  }

  if (widgetBlock) {
    const options = {
      threshold: 0.5,
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const target = entry.target;
          initWidget();
          observer.unobserve(target);
        }
      })
    }, options);

    observer.observe(widgetBlock);
  }
});
